import styled from 'styled-components';

interface ButtonProps {
  $isActive?: boolean;
  $hasReactions?: boolean;
}

const ReactionButton = styled.button<ButtonProps>`
  min-width: 45px;
  height: 25px;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background-color: ${(props) => (props.$isActive ? props.theme.primaryColor : 'transparent')};
  border-radius: 20px;
  padding: 2px 10px;
  border: ${(props) => (props.$isActive ? 'none' : '1px solid #ccc')};
  color: ${(props) => (props.$isActive ? 'white' : '#5E5E5E')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$isActive ? '#009ee6' : '#f5f5f5')};
    border-color: ${(props) => (props.$isActive ? 'transparent' : '#999')};
  }
`;

const HeartButton = styled(ReactionButton)<ButtonProps>`
  ${(props) => props.$hasReactions && `
    .anticon {
      color: #ff4757;
    }
  `}
`;

export { HeartButton, ReactionButton };
